import { EventBus } from '../../../../services/event-bus-service';
import MyBetDetailsModel from '../../../../models/mybets/model-mybet-details';
import { BETSLIP_STATUS } from 'bto-models/betslip';

export default {
  data() {
    return {
      betDetails: {},
      isLoading: false,
    };
  },
  created() {
    // Listen for BetslipGroup data sent form search-betslip
    EventBus.$on('betslipCheckerData', this.setDetails);
    // emit that the betslip checker component is created so the data can be sent
    EventBus.$emit('betslipCheckerCompCreated');
    EventBus.$on('closeIncorrectBetslipModal', this.modalHandler);
  },
  destroyed() {
    EventBus.$off('closeIncorrectBetslipModal', this.modalHandler);
    EventBus.$off('betslipCheckerData', this.setDetails);
  },
  methods: {
    onBetCashout() {
      this.betDetails = {
        ...this.betDetails,
        betSlipGroupStatusId: BETSLIP_STATUS.CACHEDOUT,
        betSlipGroupStatus: this.$translate.text('BetSlipStatusType.CachedOut'),
      };
    },
    setDetails(data) {
      this.betDetails = { ...new MyBetDetailsModel(data), isOpen: true, isVisible: true };
      EventBus.$off('betslipCheckerCompCreated');
    },
    modalHandler() {
      this.$router.push({ name: 'mybets' });
      EventBus.$emit('modalMessage', {
        showModal: false,
      });
    },
  },
};